import { useWindowSize } from "@reach/window-size"

const mobileBreakpoint = 600
const tabletBreakpoint = 1000

export function useBreakpoints() {
  const { height, width } = useWindowSize()
  const isMobile = width < mobileBreakpoint
  const isTablet = width >= mobileBreakpoint && width < tabletBreakpoint
  const isDesktop = width >= tabletBreakpoint

  return {
    height,
    width,
    isMobile,
    isTablet,
    isDesktop
  }
}
